// extracted by mini-css-extract-plugin
module.exports = {"topDelegators":"topDelegators_topDelegators__1N1xw","tableContainer":"topDelegators_tableContainer__1ZvDN"};